// services/contrato-cdc.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContratoCdc } from '../interfaces/contrato-cdc.model';
import { BaseApiService } from './base-api.service';

/**
 * Serviço responsável por integrar com a API de contratos CDC.
 * Fornece métodos para consultar listagens de contratos com base em filtros.
 */
@Injectable({
  providedIn: 'root'
})
export class ContratoCdcService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Lista contratos CDC com base nos parâmetros fornecidos.
   * @param cpfCnpj CPF ou CNPJ do cliente (obrigatório, apenas números)
   * @param status Filtro opcional de status do contrato
   * @param pagina Número da página para paginação (opcional)
   * @param registros Quantidade de registros por página (opcional)
   * @returns Observable com array de contratos CDC
   */
  listarContratos(
    cpfCnpj: string,
    status?: string,
    pagina?: number,
    registros?: number
  ): Observable<ContratoCdc[]> {
    // Monta os parâmetros da query string dinamicamente
    let params = new HttpParams().set('CpfCnpj', cpfCnpj);

    if (status) {
      params = params.set('Status', status);
    }
    if (pagina !== undefined) {
      params = params.set('Pagina', pagina.toString());
    }
    if (registros !== undefined) {
      params = params.set('Registros', registros.toString());
    }

    const url = `${this.baseUrl}/cdc-contract/by-cpfcnpj`;

    if (this.configService.isDebugEnabled()) {
      console.log('📡 Chamando API de Contratos:', url, 'Params:', params.toString());
    }

    return this.http.get<ContratoCdc[]>(url, {
      params,
      headers: this.getAuthHeaders()
    }).pipe(
      catchError(error => {
        console.error('❌ Erro na API de Contratos:', error);
        return throwError(() => error);
      })
    );
  }
}
